import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import TagGroupDetail from '../models/TagGroupDetail';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    tagGroupDetails: [],
    tagGroupSKU: [],
    skus: {},
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    orderBy: undefined,
    orderByDesc: false,
    searchTerm: undefined,
    detail: {
        tagGroupDetail: new TagGroupDetail(),
    },
};


export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TAG_GROUP_DETAIL_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.TAG_GROUP_DETAIL_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false,
                tagGroupDetails: action.result,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
            };
        
        case Types.GET_TAG_IN_TAGGROUP_ACTION:
            return { ...state, isFetching: true, tagGroupDetails: [] };
        case Types.GET_TAG_IN_TAGGROUP_SUCCESS:
            return {
                ...state,
                isFetching: false,
                tagGroupDetails: [...state.tagGroupDetails, ...action.result]
            };

        case Types.GET_TAG_BY_SKU_ACTION:
            return { ...state, isFetching: true };
        case Types.GET_TAG_BY_SKU_SUCCESS:
            return {
                ...state,
                isFetching: false,
                tagGroupSKU: action.tagGroupSKU
            };
        
        case Types.TAG_GROUP_SKU_MAPPING_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_SKU_MAPPING_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.TAG_GROUP_DETAIL_GET_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_GET_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false, detail: { ...state.detail, tagGroupDetail: action.tagGroupDetail } };

        case Types.TAG_GROUP_DETAIL_CREATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };

        case Types.TAG_GROUP_GET_ALL_SKU_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_GET_ALL_SKU_SUCCESS:
            return { ...state, isFetchingDetail: false, skus: { ...state.skus, [action.typeKey]: action.skus } };


        case Types.TAG_GROUP_DETAIL_MAP_SKU_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_MAP_SKU_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.TAG_GROUP_DETAIL_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.TAG_GROUP_DETAIL_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };
        case Types.TAG_GROUP_DETAIL_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.TAG_GROUP_DETAIL_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.TAG_GROUP_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false };

        default:
            return state;
    }
}
